import { TablePlaceFilterInput } from 'common/inputs/TablePlaceFilterInput'
import { MantineReactTable, type MRT_ColumnDef } from 'mantine-react-table'
import { useMemo } from 'react'
import { Category, PillowType, PillowVariant, Place } from 'types/products'
import { useTableWithProduct, VariantWithProduct } from './useTableWithProduct'

export function PillowTableWithProduct() {
  const columns = useMemo<Array<MRT_ColumnDef<VariantWithProduct<PillowVariant>>>>(
    () => [
      {
        accessorKey: 'product.symbol',
        header: 'Produkt',
        size: 100,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po symbolu',
        },
      },
      {
        accessorKey: 'pillowType',
        header: 'Rodzaj',
        size: 100,
        Cell: ({ cell }) => (cell.getValue<PillowType>() === PillowType.FABRIC ? 'Materiał' : 'Gotowa'),
        filterVariant: 'select',
        mantineFilterSelectProps: {
          data: Object.values(PillowType).map((place) => ({
            value: place,
            label: place === PillowType.FABRIC ? 'Materiał' : 'Gotowa',
          })),
        },
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po rodzaju',
        },
      },
      {
        accessorKey: 'size',
        header: 'Rozmiar (cm)',
        size: 100,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po rozmiarze',
        },
      },
      {
        accessorKey: 'stock',
        header: 'Ilość sztuk',
        size: 100,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po ilości',
        },
      },
      {
        accessorKey: 'place',
        header: 'Półka',
        enableSorting: false,
        size: 100,
        Cell: ({ cell }) => {
          const place = cell.getValue<Place>()
          return `${place.rack}-${place.column}-${place.shelf}`
        },
        Filter: TablePlaceFilterInput,
      },
      {
        accessorKey: 'feature',
        header: 'Cecha',
        enableSorting: false,
        size: 100,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po cesze',
        },
      },
      {
        accessorKey: 'comments',
        header: 'Uwagi',
        enableSorting: false,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po uwagach',
        },
      },
    ],
    []
  )

  const table = useTableWithProduct({
    category: Category.PILLOW,
    columns,
  })

  return <MantineReactTable table={table} />
}
